import { BreakpointsMap, constants } from "@findemdev/maui";
import styled from "styled-components";

const { dimensions } = constants;

export const RAAS_SPLIT_PANE_RESIZE_HANDLE_WIDTH = "8px";
export const RAAS_SPLIT_PANE_CHAT_MIN_WIDTH = "320px";
export const RAAS_SPLIT_PANE_ARTIFACT_MIN_WIDTH = "360px";

export const SplitPaneResizeHandle = styled.button`
  align-self: stretch;
  background: transparent;
  border: 0;
  cursor: col-resize;
  display: block;
  grid-area: resize;
  justify-self: center;
  margin: 0;
  min-height: 0;
  padding: 0;
  position: relative;
  width: ${RAAS_SPLIT_PANE_RESIZE_HANDLE_WIDTH};

  &::before {
    background: ${constants.colors["grey-200"]};
    border-radius: ${dimensions["border-radius"].sm};
    content: "";
    inset: 0 3px;
    position: absolute;
    transition: background 120ms ease;
  }

  &:hover::before,
  &:focus-visible::before {
    background: ${constants.colors["grey-400"]};
  }

  @media (max-width: ${BreakpointsMap.md}px) {
    display: none;
  }
`;
